/* eslint-disable */
// prettier-ignore

export const messages = {
  validity_period_is_start_switch: "Is Start?",
  validity_period_start: "Start",
  validity_period_valid_from: "Valid From",
  validity_period_is_end_switch: "Is End?",
  validity_period_end: "End",
  validity_period_valid_until: "Valid Until",
  validity_add_version: "Add version",
  validity_period_initial_version: "Initial version",
  validity_period_set_starting_version_date: "Set starting version date",
  validity_period_starting_from: "Starting from",
  validity_period_starting_date: "Version Start Date",

  action_dialog_processing_info: "Processing might take some time. If you don't want to wait, you can close this dialog and check the status later on the action page.",
  action_dialog_creation_error: "Unexpected error on creation of action.",
  action_dialog_polling_error: "Unexpected error on getting state of the action. Please navigate to the action page to check the status of the action.",
  action_dialog_cancelled: "Action cancelled.",
  action_dialog_failed: "Action failed.",
  action_dialog_succeeded: "Action finished.",
  action_dialog_downloadable_files: "File downloads:"
};
